import React, { useState } from 'react'
import classes from './MailSettings.module.css'
import { useTranslation } from 'react-i18next'
import { FiMail, FiX, FiUsers, FiEyeOff } from 'react-icons/fi'
import { Popover, IconButton, TextField, InputAdornment } from '@mui/material'

const MailSettings = (props) => {
    const [t] = useTranslation('common')
    const [anchorEl, setAnchorEl] = useState(null)

    const handleClick = (event) => {
        event.stopPropagation()
        setAnchorEl(event.currentTarget)
    }

    const handleClose = (event) => {
        if (event) event.stopPropagation()
        setAnchorEl(null)
    }

    // Convert semicolons to commas for backend compatibility
    const normalizeEmailSeparators = (value) => {
        return value.replace(/;/g, ',')
    }

    // Create synthetic event with preventDefault for compatibility
    const createSyntheticEvent = (value) => ({
        target: { value },
        preventDefault: () => {}
    })

    const handleToChange = (e) => {
        const normalizedValue = normalizeEmailSeparators(e.target.value)
        props.handleOnMailToChanged(createSyntheticEvent(normalizedValue), 'try')
    }

    const handleCcChange = (e) => {
        const normalizedValue = normalizeEmailSeparators(e.target.value)
        props.handleOnMailCcChanged(createSyntheticEvent(normalizedValue))
    }

    const handleBccChange = (e) => {
        const normalizedValue = normalizeEmailSeparators(e.target.value)
        props.handleOnMailBccChanged(createSyntheticEvent(normalizedValue))
    }

    const open = Boolean(anchorEl)

    return (
        <div className={classes['mail-settings-wrapper']}>
            <button
                className={classes['mail-settings-trigger']}
                onClick={handleClick}
            >
                <i className="fas fa-ellipsis-h chatIcons"></i>
            </button>

            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                slotProps={{
                    paper: {
                        className: classes['mail-settings-container'],
                        onClick: (e) => e.stopPropagation()
                    }
                }}
            >
                <div className={classes['mail-settings-header']}>
                    <div className={classes['mail-settings-header-title']}>
                        <FiMail className={classes['mail-settings-header-icon']} />
                        <span>{t('Email Recipients')}</span>
                    </div>
                    <IconButton
                        size="small"
                        onClick={handleClose}
                        className={classes['close-btn']}
                    >
                        <FiX />
                    </IconButton>
                </div>

                <div className={classes['mail-settings-content']}>
                    <div className={classes['mail-settings-field']}>
                        <TextField
                            fullWidth
                            size="small"
                            multiline
                            maxRows={3}
                            label={t('To')}
                            value={props.mailTo}
                            onChange={handleToChange}
                            placeholder={t('Enter recipient email')}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <FiMail className={classes['field-icon']} />
                                    </InputAdornment>
                                ),
                                className: classes['mail-input']
                            }}
                            className={classes['text-field']}
                        />
                    </div>

                    <div className={classes['mail-settings-field']}>
                        <TextField
                            fullWidth
                            size="small"
                            multiline
                            maxRows={3}
                            label={t('Cc')}
                            value={props.mailCc}
                            onChange={handleCcChange}
                            placeholder={t('Carbon copy recipients')}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <FiUsers className={classes['field-icon']} />
                                    </InputAdornment>
                                ),
                                className: classes['mail-input']
                            }}
                            className={classes['text-field']}
                        />
                    </div>

                    <div className={classes['mail-settings-field']}>
                        <TextField
                            fullWidth
                            size="small"
                            multiline
                            maxRows={3}
                            label={t('Bcc')}
                            value={props.mailBcc}
                            onChange={handleBccChange}
                            placeholder={t('Blind carbon copy')}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <FiEyeOff className={classes['field-icon']} />
                                    </InputAdornment>
                                ),
                                className: classes['mail-input']
                            }}
                            className={classes['text-field']}
                        />
                    </div>

                    <p className={classes['helper-text']}>{t('Separate multiple emails with comma or semicolon')}</p>
                </div>
            </Popover>
        </div>
    )
}

export default MailSettings
